import { format } from "date-fns";
const defaultLogger = (service, message, level) => {
    switch (level) {
        case "log":
            return console.log(`${format(new Date(), "HH:mm:ss.SSS")} - ${service} - ${message}`);
        case "error":
            return console.error(`${format(new Date(), "HH:mm:ss.SSS")} - ${service} - ${message}`);
    }
};
export let debugLoggerFn = null;
export let errorLoggerFn = null;
const devMode = process.env.NODE_ENV === "development" || // react-native
    process.env.NODE_ENV === "dev"; // react
export let debugOn = devMode;
export function debugLog(service, message) {
    const shouldLog = debugOn && process.env["DEBUG_SHARED_LIBRARY_OFF"] !== "true";
    if (shouldLog) {
        if (debugLoggerFn) {
            debugLoggerFn(service, message);
        }
        else {
            defaultLogger(service, message, "log");
        }
    }
}
export function errorLog(service, message) {
    if (errorLoggerFn) {
        errorLoggerFn(service, message);
    }
    else {
        defaultLogger(service, message, "error");
    }
}
export function setDebugLogger(fn) {
    debugLoggerFn = fn;
}
export function setErrorLogger(fn) {
    errorLoggerFn = fn;
}
export function setDebugLoggingOn(state) {
    debugOn = state;
}
//# sourceMappingURL=logger.js.map